import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";

@Component({
  selector: "ngx-goods-formula-form",
  templateUrl: "./goods-formula-form.component.html",
  styleUrls: ["./goods-formula-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoodsFormulaFormComponent extends BaseFormComponent<any> {
  @Input() _columns: form_control[] = [];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.noLoadData = true;
    super.ngOnInit();
  }
  async setColumns() {
    this.orignalColumns = this._columns as form_control[];
    this.columns = (this._columns as form_control[]).filter(
      (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
    );
    this.columns = this.columns.sort((a, b) => a.order - b.order);
    this.setColumnAttribute();
    this.setColumnNumber(this.columns);
    this.setFormGroup(this.model);
  }
  addControl() {
    this.cd.markForCheck();
  }
  async save() {
    if (this.formGroup?.valid) {
      this.result = this.getDataFromFormGroup();
      this.closeModal();
    }
  }
  cancel() {
    this.closeModal();
  }
  onChange($event) {
    if ($event && $event.data && $event.data.Title && $event.apiName !== "Branch/ReadLookUp") {
      this.model.GoodsCode = $event.data.Code;
      this.model.GoodsTitle = $event.data.Title;
      this.model.GoodsKindCode = $event.data.GoodsKindCode;
      this.model.GoodsKindTitle = $event.data.GoodsKindTitle;
      this.setValue("GoodsCode", $event.data.Code);
      this.setValue("GoodsTitle", $event.data.Title);
      this.setValue("GoodsKindCode", $event.data.GoodsKindCode);
      this.setValue("GoodsKindTitle", $event.data.GoodsKindTitle);
      if ($event.data.UnitTitle) {
        this.model.UnitTitle = $event.data.UnitTitle;
        this.setValue("UnitTitle", $event.data.UnitTitle);
      }
    }
    if($event.apiName === "Goods/GetPagining" && $event?.data?.Id && ($event?.data?.Id === this.currentrow?.Id || $event?.data?.Id === this.currentrow?.HeaderGoodsId)){
      this.sts.showDialog('کالای انتخاب شده برای استفاده در انالیز غیرمجاز میباشد','توجه');
      this.setValue('GoodsId' , null);
    }
  } 
}
